/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2026-01-27 19:52:57
 * @LastEditors: ryanxu ryanxu@chaocanshu.ai
 * @LastEditTime: 2026-03-27 16:16:11
 * @FilePath: /knit-web/src/locale/en-US/menu.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  menu: {
    homepage: 'Homepage',
    home: 'Home',
    faq: 'FAQ',
    arcoWebsite: 'Arco Website',
    organization: {
      title: 'Organization',
      company: 'Company',
      department: 'Department',
      departmentEdit: 'DepartmentEdit',
      user: 'User',
      userDetail: 'UserDetail',
    },
    application: 'Application Center',
    discover: {
      title: 'Discover',
      appMarket: 'App Marketplace',
      toolMarket: 'Tool Marketplace',
      toolDetail: 'Tool Detail',
    },
    develop: {
      title: 'Develop',
      scheduler: 'Scheduler',
      workflow: {
        title: 'Workflow',
        index: 'My Workflows',
        detail: 'Workflow Detail',
        execution: 'Execution History',
        executionDetail: 'Execution Detail',
      },
      evaluation: {
        title: 'Evaluation & Cost',
        datasets: 'Datasets',
        experiments: 'Experiments',
        cost: 'Cost Governance',
      },
      tool: {
        title: 'Tool',
        index: 'My Tools',
      },
      configuration: 'My Configurations',
    },
    deploy: {
      title: 'Deploy',
      database: {
        title: 'Databases',
        mysql: 'MySQL',
        postgres: 'Postgres',
        milvus: 'Milvus',
      },
      knowledge: {
        title: 'Knowledge Bases',
        knowledge: 'Knowledge',
        knowledgeDetail: 'Knowledge Detail',
        knowledgeBaseDetail: 'Knowledge Base Detail',
        knowledgeDocumentDetail: 'Knowledge Document Detail',
      },
      apps: 'Workers',
    },
    contact: 'Contact Us',
    config: 'Config Center',
    document: 'Document Center',
    evaluation: {
      title: 'Evaluation',
      experiments: 'Experiments',
      create: 'Create Experiment',
      edit: 'Edit Experiment',
      detail: 'Experiment Detail',
    },
    protocol: {
      title: 'Protocol',
      create: 'Create Protocol',
      bind: 'Bind Workflow',
    },
    template: 'Resource Template',
    changelog: 'Changelog',
  },
};
